import { FC, useEffect, useState } from "react";
import {
    Col,
    Container,
    InputGroup,
    Row,
    Stack
} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { eyeOff, eyeOn } from "../../utils/Icons";
import CustomError from "../../utils/CustomError";
import {
    sessionJoin,
} from "../../api/request";
import { useNavigate } from "react-router-dom";



interface joinModal {
    show: boolean;
    onClose: () => void;
}

const JoinSession: FC<joinModal> = (props) => {

    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [errorAdmin, setErrorAdmin] = useState(false);
    const [useremail, setEmail] = useState<string>();
    const [password, setPassword] = useState<string>();
    const [error, setError] = useState({
        show: false,
        class: "",
        message: "",
    });

    const handleLogin = async () => {
        let payload = {
            session_id: useremail,
            password: password,
        };
        const response = await sessionJoin(payload);
        if (response.flag) {
            const personList = response?.result?.personas;
            const listName = personList.map((name: any) => name?.name);
            localStorage.setItem('chat-mode', `paid`);
            localStorage.setItem('paidMode', `?type=paid&name=${listName}`);
            localStorage.setItem('sessionID', `${useremail}`);
            navigate('/persona-selection');
        } else {
            setError({
                show: true,
                class: "show-error",
                message: response?.response?.data?.message,
            });
        }
    };


    useEffect(() => {
        const timer = setTimeout(() => {
            setError({
                show: false,
                class: "",
                message: "",
            });
            setErrorAdmin(false);
        }, 3000);
        return () => {
            clearTimeout(timer);
        };
    }, [errorAdmin, error]);

    return (
        <>
            {error.show && (
                <CustomError
                    class={`mt-3 ${error?.class} right-side`}
                    message={error?.message}
                />
            )}
            <Modal
                className="admin-modal"
                show={props.show}
                onHide={props.onClose}
                keyboard={false}
                centered
            >
                <>
                    <Modal.Header className="justify-content-center pt-lg-4 pt-2">
                        <Modal.Title>Join Session</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pb-lg-5 pb-2">
                        <section className="login-page p-0">
                            <Container className="">
                                <Row className=" align-items-center justify-content-center">
                                    <Col xxl={11} lg={10} md={12} className="text-center">
                                        <Stack className="mt-3">
                                            <InputGroup className="mb-3">
                                                <input
                                                    className="form-control"
                                                    autoComplete="new-password"
                                                    placeholder="Session ID"
                                                    onChange={(e: any) => setEmail(e.target.value)}
                                                />
                                            </InputGroup>
                                            <InputGroup className="mb-3">
                                                <input
                                                    className="form-control"
                                                    autoComplete="new-password"
                                                    placeholder="Session Password"
                                                    type={showPassword !== true ? "password" : "text"}
                                                    onChange={(e: any) => setPassword(e.target.value)}
                                                    onKeyDown={(key: any) => {
                                                        if (key.key === "Enter") {
                                                            handleLogin();
                                                        }
                                                    }}
                                                />
                                                <Button
                                                    onClick={() =>
                                                        setShowPassword((prevState) => !prevState)
                                                    }
                                                    type="button"
                                                    variant="eye-icon"
                                                >
                                                    {showPassword ? eyeOn() : eyeOff()}
                                                </Button>

                                            </InputGroup>
                                            <div>
                                                <Button
                                                    type="button"
                                                    variant="secondary"
                                                    className="w-100"
                                                    onClick={() => handleLogin()}
                                                >
                                                    <div className="my-1 weight-bold">Join</div>
                                                </Button>
                                            </div>
                                        </Stack>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                    </Modal.Body>
                </>
            </Modal>
        </>
    );
};
export default JoinSession;
